var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"action-details"},[_c('h2',{staticClass:"form-title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"info"},[_vm._v(_vm._s(_vm.description))])])}
var staticRenderFns = []

export { render, staticRenderFns }